import React, { Component } from 'react';
import { Button } from '@veneer/core';

class NotFound extends Component {
  render() {
    console.log(this.props);
    return (
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-bg">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <h1>oops!</h1>
          <h2>Error 404 : Page Not Found</h2>
          <Button
            appearance="critical"
            onClick={() => {
              document.location = '/';
            }}
          >
            Go to Home
          </Button>
        </div>
      </div>
    );
  }
}

export default NotFound;
